"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _layout = require("../layout");
var _popover = require("../popover");
var _responsive = require("../responsive");
var _screenReaderOnly = require("../screen-reader-only");
var _text = require("../text");
var _utils2 = require("../utils");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _propTypes = _interopRequireDefault(require("./propTypes"));
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const convertToPopoverPosition = (position, alignment) => {
  if (position === _interfaces.TOOLTIP_POSITION.TOP) {
    if (alignment === _interfaces.TooltipAlignment.Left) {
      return _popover.PopoverPosition.TopLeading;
    } else if (alignment === _interfaces.TooltipAlignment.Right) {
      return _popover.PopoverPosition.TopTrailing;
    } else {
      return _popover.PopoverPosition.TopCenter;
    }
  } else {
    if (alignment === _interfaces.TooltipAlignment.Left) {
      return _popover.PopoverPosition.BottomLeading;
    } else if (alignment === _interfaces.TooltipAlignment.Right) {
      return _popover.PopoverPosition.BottomTrailing;
    } else {
      return _popover.PopoverPosition.BottomCenter;
    }
  }
};
class TooltipProvider extends _react.default.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      id: "StencilReactTooltip-".concat((0, _utils2.getUniqueId)()),
      isOpen: false
    });
    (0, _defineProperty2.default)(this, "triggerRef", /*#__PURE__*/(0, _react.createRef)());
    (0, _defineProperty2.default)(this, "tooltipRef", /*#__PURE__*/(0, _react.createRef)());
    (0, _defineProperty2.default)(this, "open", () => {
      this.setState({
        isOpen: true
      });
    });
    (0, _defineProperty2.default)(this, "close", () => {
      this.setState({
        isOpen: false
      });
    });
  }
  render() {
    const {
      tooltipPosition = _interfaces.TOOLTIP_POSITION.TOP,
      tooltipAlignment = _interfaces.TooltipAlignment.Center,
      tooltipText,
      onOpened,
      onClosed,
      tooltipDataTestId,
      children
    } = this.props;
    const {
      id,
      isOpen
    } = this.state;
    const {
      triggerRef,
      tooltipRef
    } = this;
    const dataTestProps = (0, _utils2.buildDataTestProps)({
      dataTestComponent: 'StencilReactTooltip',
      dataTestId: tooltipDataTestId
    });
    const position = convertToPopoverPosition(tooltipPosition, tooltipAlignment);
    return (0, _react2.jsx)(_responsive.WithBreakpoints, null, viewport => {
      const maxWidth = viewport.matches.s ? "calc(100vw - ".concat(_constants.MARGIN_MOBILE * 2, "px)") : _constants.MAX_WIDTH_DESKTOP;
      return (0, _react2.jsx)(_react.default.Fragment, null, children({
        triggerRef,
        tooltipRef,
        open: this.open,
        close: this.close,
        isOpen,
        tooltipId: id
      }), !isOpen && (0, _react2.jsx)(_screenReaderOnly.ScreenReaderOnly, {
        hidden: true,
        id: id
      }, tooltipText), (0, _react2.jsx)(_popover.PopoverController, {
        target: triggerRef,
        isOpen: isOpen,
        close: this.close,
        position: position,
        onOpened: onOpened,
        onClosed: onClosed,
        shouldFocusOnOpen: false,
        shouldCloseOnFocusLeave: false
      }, (0, _react2.jsx)(_layout.View, {
        padding: "S300",
        maxWidth: maxWidth,
        ref: tooltipRef
      }, (0, _react2.jsx)(_text.Text, (0, _extends2.default)({
        role: "tooltip",
        id: id,
        "aria-hidden": true,
        variant: _text.TextVariant.BodySM,
        color: (0, _utils.token)('color.text.primary')
      }, dataTestProps), tooltipText))));
    });
  }
}
(0, _defineProperty2.default)(TooltipProvider, "displayName", 'TooltipProvider');
(0, _defineProperty2.default)(TooltipProvider, "defaultProps", {
  tooltipPosition: _interfaces.TOOLTIP_POSITION.TOP,
  tooltipAlignment: _interfaces.TooltipAlignment.Center
});
const TooltipProviderWithDocs = (0, _stencilReactDesc.describe)(TooltipProvider).description('FAC component which displays tooltips.');
TooltipProviderWithDocs.propTypes = _propTypes.default;
var _default = exports.default = TooltipProviderWithDocs;